import script from "./CourseAbout.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseAbout.vue?vue&type=script&setup=true&lang=js"

import "./CourseAbout.vue?vue&type=style&index=0&id=65679cd5&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65679cd5"]])

export default __exports__